import React from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';

interface CheckboxItemProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const LastMonthMembershipOptionCheckbox: React.FC<CheckboxItemProps> = ({ label, checked, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: '2rem',
            },
            color: '#ffa907',
            '&.Mui-checked': {
              color: '#ffa907',
            },
          }}
        />
      }
      label={label}
      sx={{
        '& .MuiFormControlLabel-label': {
          fontSize: '1.6rem',
          fontWeight: 'bold',
        },
      }}
    />
  );
};

export default LastMonthMembershipOptionCheckbox;
